import { EmailResourceType } from '../../models/resource-services';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createEmailResourcesDownloadTicket: (
  fetchContext: FetchContext,
  resourceType: EmailResourceType,
  accessToken?: string,
) => Promise<string> = (fetchContext, resourceType, accessToken) => {
  const params = new URLSearchParams();
  params.append('resourceType', `${resourceType}`);

  const url = `${fetchContext.baseUrl}/api/email-resources${params.size > 0 ? `?${params}` : ''}`;

  return fetch(url,
  {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  }).then((response) => responseErrorHandler<string>(fetchContext.errorStore, response, 'create email resources download ticket', false))
};
